import TaskDTO from 'models/dto/tasks/taskDTO';

export class TaskRelationDTO {
  taskTaskId: number;

  taskIdFrom: number;

  taskIdTo: number | null;

  relationship: number;

  taskFrom?: TaskDTO;

  taskTo?: TaskDTO;

  notifyUserId?: string;

  constructor() {
    this.taskTaskId = 0;
    this.taskIdFrom = 0;
    this.taskIdTo = null;
    this.relationship = 0;
  }
}
